import { Heading, Paragraph } from "@/components/ui/Typography";
import type { MicroSite } from "@/lib/api";
import { sanitizeHtml } from "@/utils/helpers/html";

const Overview = ({data}:{data: MicroSite}) => {
  if(!data){
    return null;
  };

  const PreviewComponent = () => {
    return (
      <div className="grid gap-4 md:grid-cols-2 md:gap-8 relative flex-col w-full items-center p-4 lg:p-20 lg:gap-16 justify-center" style={{backgroundColor: data?.branding?.websiteColorCode}} >   
          <div className="flex items-center gap-3">
          <Heading level={1} style={{color: data?.branding?.textColorCode}}>{data?.headerSectionTwo?.headerSectionTwoTitle}</Heading>
          </div>
          <Paragraph  style={{color: data?.branding?.textColorCode}} dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.headerSectionTwo?.headerSectionTwoDescription ?? "") }} ></Paragraph>
      </div>
    )
  };

  return (
    <div>
      <PreviewComponent />
    </div>
  )
}

export default Overview